<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value">
            <el-date-picker style="width: 170px" :disabled="disabled" :type="dateType" :style="getStyle()" v-model="curValue" :format="format" :value-format="format" @change="syncModel"></el-date-picker>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    //有效的值类型
    let validValueTypes_datetime = ['String', 'Date'];
    let validValueTypes_puredate = ['String', 'Date', 'Integer'];

    function isValidValueType(valueType, withTime) {
        let validValueTypes = withTime ? validValueTypes_datetime : validValueTypes_puredate;
        return validValueTypes.indexOf(valueType) != -1;
    }

    //转成按yyyy-MM-dd格式显示的文本
    export function formatIntegerDate(dateVal, format) {
        //console.log(dateVal);
        if (dateVal == null) {
            return null;
        }
        format = format || 'yyyy-MM-dd';
        if (Utils.isDate(dateVal)) {
            return dateVal.format(format);
        }
        let dateStr = dateVal + '';
        if (Utils.isNoB(dateStr)) {
            return null;
        }
        if (Utils.isNumStr(dateStr, 0) && dateStr.length >= 8) {
            dateStr = dateStr.substring(0, 8);
            return dateStr.substring(0, 4) + '-' + dateStr.substring(4, 6) + '-' + dateStr.substring(6);
        } else {
            return dateStr;
        }
    }

    function parseDateByValueType(dateVal, valueType) {
        if (valueType == 'Integer') {
            dateVal = formatIntegerDate(dateVal);
        }
        return typeof dateVal == 'string' ? Date.parseAsDate(dateVal) : dateVal;
    }

    function getModelResultValue(curValue, valueType, format) {
        let resultValue = curValue;
        if (resultValue != null) {
            resultValue = Date.parseAsDate(resultValue);
            //
            if (Utils.isDate(resultValue)) {
                if (valueType == 'String') {
                    resultValue = resultValue.format(format);
                } else if (valueType == 'Integer') {
                    resultValue = Utils.ParseInt(resultValue.format('yyyyMMdd'));
                }
            }
        }
        return resultValue;
    }

    //
    export default {
        name: 'swb-query-date-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'String'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            time: {//是否使用时间部分
                //type: Boolean,
                default: false
            },
            iniValue: {
                default: null
            }
        },
        //
        data() {
            return {
                dateType: 'date',
                format: 'yyyy-MM-dd',
                //
                curValue: null
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        beforeDestroy() {
            //data
            this.curValue = null;
        },
        //
        methods: {
            getStyle() {
                return this.dateType == 'datetime' ? {width: '170px'} : {width: '170px'};
            },
            init() {
                this.dateType = this.time == true ? 'datetime' : 'date';
                this.format = this.dateType == 'datetime' ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
                //
                if (!isValidValueType(this.valueType, this.time)) {
                    let validValueTypes = this.time ? validValueTypes_datetime : validValueTypes_puredate;
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if (typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    } else {
                        MsgBox.error(message);
                    }
                }
                let iniValue = this.iniValue || null;
                //初始化
                this.curValue = parseDateByValueType(iniValue);
                this.syncModel();
            },
            syncModel() {
                let resultValue = getModelResultValue(this.curValue, this.valueType, this.format);
                this.$emit('input', resultValue);
                //
                this.$emit('valueformat', this.format);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QueryDateField.vue